<!------------------create lead----------------->
<div class="card card-success wd">

    <form class="center">
        <h1>Contact Creation</h1>
    </form>
   
    <form>
    <div class="card-body">

        <div class="form-group">
            <label for="exampleInputPassword1">First Name</label><span class="error">{{NameAlert}}</span>
            <input type="text" class="form-control" placeholder="Name" name="name" [(ngModel)]="data.first_name"  (ngModelChange)="valuechange1($event)" >
        </div>

        <div class="form-group">
            <label for="exampleInputPassword1">Last Name</label>
            <input type="text" class="form-control" placeholder="Name" name="name" [(ngModel)]="data.last_name" >
        </div>
        
            
    
        <div class="form-group">
            <label for="exampleInputPassword1">Email</label><span class="error">{{EmailAlert}}</span>
            <input type="email" class="form-control" placeholder="Email" name="email" [formControl]="email" [(ngModel)]="data.email" (ngModelChange)="valuechange3($event)">
        </div>
               
        <div class="form-group">
            <label for="exampleInputPassword1">Contact 1</label><span class="error">{{MobileAlert}}</span>
            <input type="number" class="form-control" placeholder="Contact1" name="mobile1" [formControl]="mobile1" [(ngModel)]="data.contact_1"  (ngModelChange)="valuechange2($event)">
        </div>

        <div class="form-group">
            <label for="exampleInputPassword1">Contact 2</label>
            <input type="number" class="form-control" placeholder="Contact2"  [(ngModel)]="data.contact_2">
        </div>
    </div>
</form>
 <!-------------------Test alert---------------------->
 <div class="alert alert-success alert-dismissible alertWidth" *ngIf="isChange">
    <button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="shown()">×</button>
    <h4><i class="icon fas fa-check"></i> {{alert}}</h4>
     
    </div>
<!----------------------------------------------------------------------------------------------->

        <div class="card-footer">
            <button class="btns"  mat-raised-button (click)="AddLeads();">
                <span class="mdc-button__label colr" >Added</span>
            </button>

   
    </div>
    
    </div>
